// src/main.js
import '/global.css'; // now it’s valid because postcss plugin will handle it
import App from './App.svelte';

const app = new App({
  target: document.body
});

export default app;
